// extracted by mini-css-extract-plugin
export var highlightOriginal = "_63-0";
export var highlightSuggested = "_63-1";